/**
 * Lift2Fit — the calendar's date range and cache key, in ONE place.
 *
 * The Calendar screen asks for "this week" with a from/to pair that is part of
 * the cache key, and a prefetch has to ask for exactly the same pair or it fills
 * a slot nothing reads. Duplicating `startOfIsoWeek`-then-+7-days in two files is
 * how those two drift apart, so both import this.
 */
import { readKey } from './readCache';

/** The Monday 00:00 of the week containing `anchor`, matching the ISO week. */
export function startOfIsoWeek(anchor: Date): Date {
  const date = new Date(anchor.getFullYear(), anchor.getMonth(), anchor.getDate());
  const weekday = (date.getDay() + 6) % 7; // Monday = 0
  date.setDate(date.getDate() - weekday);
  return date;
}

export function addDays(date: Date, days: number): Date {
  const next = new Date(date.getTime());
  next.setDate(next.getDate() + days);
  return next;
}

export interface WeekRange {
  from: string;
  to: string;
}

/** The ISO range the Calendar asks the API for, for the week containing `anchor`. */
export function weekRange(anchor: Date = new Date()): WeekRange {
  const start = startOfIsoWeek(anchor);
  return { from: start.toISOString(), to: addDays(start, 7).toISOString() };
}

/** The cache key for that range — used by the screen and by the prefetch. */
export function calendarKey(range: WeekRange): string {
  return readKey('crm/slots', { from: range.from, to: range.to });
}
